import React, { useRef, useState } from 'react';
import {
   Box,
   Button,
   IconButton,
   Paper,
   Typography,
   Backdrop,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/pro-light-svg-icons/faTimesCircle';
import { Input } from '../../../assets/styled/Element';
import { useForm } from 'react-hook-form';
import Axios from 'axios';
import LoadingPopup from '../../Loading/LoadingPopup';
import ErrorPopup from '../../Error/ErrorPopup';
import { useSnackbar } from 'notistack';
import { LogToBackend } from '../../../configs/helpers/LogToBackend';

const useStyles = makeStyles((theme) => ({
   backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: '#fff',
   },
   paper: {
      padding: theme.spacing(2, 4, 3),
      width: '400px',
      borderRadius: '7.5px',
      maxHeight: '95vh',
      overflow: 'auto',
   },
   role: {
      color: '#5858FA',
   },
   title: {
      color: '#6E6E6E',
   },
   large: {
      width: theme.spacing(8),
      height: theme.spacing(8),
   },
   header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignContent: 'center',
      alignItems: 'center',
      margin: theme.spacing(1, 0),
   },
   content: {
      margin: theme.spacing(0, 1),
      width: '100%',
   },
   headerL: {
      margin: theme.spacing(1),
   },
   listStyle: {
      height: '65px',
   },
   flexGrid: {
      display: 'flex',
      alignItems: 'center',
   },
   qrPaper: {
      display: 'flex',
      justifyContent: 'center',
      alignContent: 'center',
      alignItems: 'center',
      height: '100%',
      width: '100%',
   },
   detailRight: {
      height: '280px',
      overflow: 'auto',
   },
}));
function Delete(props) {
   const classes = useStyles();
   const [data, setData] = useState(props.data);
   const [isLoading, setIsLoading] = useState(false);
   const [isError, setIsError] = useState({
      error: false,
      errorStatus: '',
      errorMessage: '',
   });
   const closeRef = useRef();
   const { enqueueSnackbar, closeSnackbar } = useSnackbar();
   const {
      handleSubmit,
      control,
      register,
      errors,
      watch,
      setValue,
      getValues,
   } = useForm();
   const onSubmit = (e) => {
      if (e.submitCode !== data.walletCode) {
         enqueueSnackbar('รหัสกระเป๋าธนาคารไม่ถูกต้อง', {
            variant: 'error',
         });
      } else {
         sessionStorage.setItem('value', JSON.stringify(e));
         if (sessionStorage['value']) {
            const values = JSON.parse(sessionStorage.getItem('value'));
            postData(values);
         }
      }
   };
   const postData = (values) => {
      setIsLoading(true);
      Axios.delete(
         `/GSB/dashboard/wallet/DeleteBankWallet?walletId=${data.walletId}`,
      )
         .then((resp) => {
            // console.log(resp);
            enqueueSnackbar('ลบรายการสำเร็จ!!', {
               variant: 'success',
            });
            props.onSuccess();
         })
         .catch((e) => {
            LogToBackend(e);
            if (e.response) {
               const response = e.response.data;
               enqueueSnackbar(response.errorAppMessageTh, {
                  variant: 'error',
               });
            } else console.error('site error');
         })
         .finally(() => {
            sessionStorage.removeItem('value');
            setIsLoading(false);
         });
   };
   if (isError.error)
      return (
         <ErrorPopup
            onClick={props.onClickClose}
            errorStatus={isError.errorStatus}
            errorMessage={isError.errorMessage}
         />
      );
   return (
      <Paper className={classes.paper}>
         <Backdrop className={classes.backdrop} open={isLoading}>
            <LoadingPopup />
         </Backdrop>
         <div className={classes.header}>
            <Typography variant={'h4'}>ลบกระเป๋าธนาคาร</Typography>
            <IconButton
               className={classes.headerL}
               size={'small'}
               onClick={props.onClickClose}
               ref={closeRef}
            >
               <FontAwesomeIcon icon={faTimesCircle} />
            </IconButton>
         </div>
         <form onSubmit={handleSubmit(onSubmit)}>
            <Box
               display={'flex'}
               alignItems={'flex-start'}
               flexDirection={'column'}
               fontSize={20}
            >
               <Box>ต้องการกระเป๋าธนาคาร นี้ใช่หรือไม่</Box>
               <Box>รหัสกระเป๋าธนาคาร : {data.walletCode}</Box>
               <Box width={'100%'}>
                  <Input
                     name={'submitCode'}
                     placeholder={
                        'กรุณาระบุรหัสกระเป๋าธนาคาร อีกครั้งเพื่อยืนยัน'
                     }
                     ref={register({ required: true })}
                     width={'100%'}
                  />
               </Box>
               <Box mt={3}>
                  <Box>
                     <Button
                        variant={'contained'}
                        color={'primary'}
                        type={'submit'}
                     >
                        ยืนยัน
                     </Button>
                     <Button variant={'contained'} onClick={props.onClickClose}>
                        ยกเลิก
                     </Button>
                  </Box>
               </Box>
            </Box>
         </form>
      </Paper>
   );
}

export default Delete;
